import React, { useState } from 'react';
import { Box ,Typography } from '@mui/material';
import '../Maingallery.css';
import ScopeCard from './ScopeCard';

// material
// components
// ----------------------------------------------------------------------
export default function Onescope({scope, index}) {
  const [scopetitle , setScopetitle] = useState([scope.title]);
  const [scopeid , setScopeid] = useState([scope.id]);

  
  
  
  const goScope = () => {
    const url =`/files/scope/${scopeid}/${scopetitle}/`;
    window.location = url ;
  };

  return (
        <Box onClick={goScope}  sx={{  border:'.5px solid #d0d0d0', padding:'0px' , borderRadius:.5 ,backgroundColor:'white',  boxShadow:'rgba(0, 0, 0, .15 ) 0 3px 9px 0' ,
          "&:hover": {
         boxShadow:'none', background: '#f3f3f3',
         cursor:'pointer',
          
        },}} > 
                  <>
            <ScopeCard key={scope.id} scope={scope}  index={index} />
            <Typography sx={{px:1,   whiteSpace: 'nowrap' , 
        overflow: 'hidden',
        fontWeight:'600',
        textoverflow: 'ellipsis',
        width: '11.5rem' ,
        "&:hover": {
          
          fontWeight:'800',
           
         } }}> {scopetitle}</Typography>  </>       


        </Box>

       

  );
}

const item = [
    {
      img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
      title: 'Breakfast',
      author: '@bkristastucchio',
      featured: true,
    },
 
]